import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TagColor } from './tag-color.type';

@Component({
  selector: 'govuk-tag',
  template: `
    <strong class="govuk-tag {{ color ? 'govuk-tag--' + color : '' }}">
      <ng-content></ng-content>
    </strong>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  @Input() color: TagColor;
}
